// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.adn__stats-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 1rem;
}
.adn__stat-card {
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
}
.adn__stat-top {
  display: flex;
  align-items: center;
  gap: 0.7rem;
}
.adn__stat-icon {
  width: 2.5rem;
  height: 2.5rem;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.adn__stat-label {
  font-size: 0.82rem;
  font-weight: 600;
  color: var(--admin-muted);
  margin: 0;
}
.adn__stat-value {
  font-family: var(--font-body);
  font-size: 2rem;
  font-weight: 700;
  color: var(--admin-text);
  margin: 0;
  line-height: 1;
}
.adn__stat-change {
  display: flex;
  align-items: center;
  gap: 0.3rem;
  font-size: 0.75rem;
  font-weight: 500;
  margin: 0;
}
.adn__stat-change.up {
  color: var(--admin-green);
}
.adn__stat-change.down {
  color: var(--admin-red);
}

.adn__layout {
  display: grid;
  grid-template-columns: 1fr;
  gap: 1rem;
}
.adn__layout--detail {
  grid-template-columns: 1fr 340px;
  align-items: start;
}

.adn__filters {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  flex-wrap: wrap;
  margin-bottom: 0.75rem;
}
.adn__date-filter {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.6rem 0.9rem;
  border: 1px solid var(--admin-border);
  border-radius: 8px;
  background: #fff;
  font-size: 0.84rem;
  color: var(--admin-text);
  white-space: nowrap;
  cursor: pointer;
}

.adn__table-card {
  padding: 0;
  overflow: hidden;
}
.adn__table {
  width: 100%;
  border-collapse: collapse;
}
.adn__table th {
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--admin-muted);
  padding: 0.75rem 1rem;
  border-bottom: 1px solid var(--admin-border);
  text-align: left;
  background: #fafaf8;
}
.adn__table td {
  padding: 0.85rem 1rem;
  border-bottom: 1px solid #f0ebe4;
  vertical-align: middle;
}
.adn__table tbody tr:last-child td {
  border-bottom: none;
}

.adn__email-cell {
  font-size: 0.82rem;
  color: var(--admin-muted);
}
.adn__amount-cell {
  font-size: 0.88rem;
  font-weight: 700;
  color: var(--admin-text);
  margin: 0;
}
.adn__currency-cell {
  font-size: 0.7rem;
  color: var(--admin-muted);
  margin: 0;
}
.adn__campaign-cell {
  font-size: 0.82rem;
  color: var(--admin-text);
}

.adn__badge {
  display: inline-flex;
  align-items: center;
  font-size: 0.72rem;
  font-weight: 600;
  padding: 0.22rem 0.65rem;
  border-radius: 99px;
}
.adn__badge--completed {
  background: rgba(22, 163, 74, 0.1);
  color: var(--admin-green);
}
.adn__badge--pending {
  background: rgba(217, 119, 6, 0.12);
  color: var(--admin-amber);
}
.adn__badge--refunded {
  background: rgba(220, 38, 38, 0.1);
  color: var(--admin-red);
}

/* Detail panel */
.adn__detail {
  background: #fff;
  border: 1px solid var(--admin-border);
  border-radius: 10px;
  overflow: hidden;
  position: sticky;
  top: calc(var(--admin-topbar-h)+1rem);
}
.adn__detail-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem;
  border-bottom: 1px solid var(--admin-border);
}
.adn__detail-title {
  font-size: 0.95rem;
  font-weight: 700;
  color: var(--admin-text);
  margin: 0;
}
.adn__detail-close {
  background: none;
  border: none;
  cursor: pointer;
  font-size: 1rem;
  color: var(--admin-muted);
  padding: 0.2rem;
  border-radius: 4px;
}
.adn__detail-close:hover {
  background: #f3f4f0;
}

.adn__detail-user {
  display: flex;
  gap: 0.75rem;
  padding: 1rem;
  align-items: flex-start;
  border-bottom: 1px solid var(--admin-border);
}
.adn__detail-avatar {
  width: 2.4rem;
  height: 2.4rem;
  border-radius: 50%;
  color: #fff;
  font-size: 0.72rem;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.adn__detail-name {
  font-size: 0.95rem;
  font-weight: 700;
  color: var(--admin-text);
  margin: 0 0 0.15rem;
}
.adn__detail-email {
  font-size: 0.75rem;
  color: var(--admin-muted);
  margin: 0 0 0.1rem;
}

.adn__detail-amount-block {
  padding: 1rem;
  border-bottom: 1px solid var(--admin-border);
}
.adn__detail-amount {
  font-family: var(--font-serif);
  font-size: 1.6rem;
  font-weight: 700;
  color: var(--admin-text);
  margin: 0 0 0.4rem;
}
.adn__detail-amount span {
  font-size: 0.85rem;
  color: var(--admin-muted);
  font-family: var(--font-body);
  font-weight: 400;
}
.adn__detail-date {
  font-size: 0.75rem;
  color: var(--admin-muted);
  margin: 0.4rem 0 0.1rem;
}
.adn__detail-txid {
  font-size: 0.7rem;
  color: var(--admin-muted);
  margin: 0;
  font-family: monospace;
}

.adn__detail-rows {
  padding: 0.75rem 1rem;
  border-bottom: 1px solid var(--admin-border);
  display: flex;
  flex-direction: column;
  gap: 0.6rem;
}
.adn__detail-row {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 0.75rem;
}
.adn__detail-key {
  font-size: 0.78rem;
  color: var(--admin-muted);
  flex-shrink: 0;
}
.adn__detail-val {
  font-size: 0.78rem;
  font-weight: 500;
  color: var(--admin-text);
  text-align: right;
}

.adn__detail-actions {
  padding: 0.85rem 1rem;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}
.adn__detail-section-title {
  font-size: 0.8rem;
  font-weight: 700;
  color: var(--admin-text);
  margin: 0 0 0.5rem;
}
.adn__action-full {
  width: 100%;
}
.adn__refund-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.4rem;
  width: 100%;
  padding: 0.65rem;
  border: none;
  border-radius: 6px;
  background: transparent;
  color: var(--admin-red);
  font-size: 0.82rem;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.15s;
}
.adn__refund-btn:hover {
  background: rgba(220, 38, 38, 0.06);
}

@media (max-width: 1199px) {
  .adn__stats-grid {
    grid-template-columns: repeat(2, 1fr);
  }
  .adn__layout--detail {
    grid-template-columns: 1fr;
  }
}
@media (max-width: 767px) {
  .adn__stats-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

.ann__toast { display:flex; align-items:center; gap:0.5rem; background:rgba(22,163,74,0.1); border:1px solid rgba(22,163,74,0.3); border-radius:8px; padding:0.65rem 1rem; font-size:0.84rem; font-weight:600; color:#16a34a; animation:slideDown 0.25s ease; }
@keyframes slideDown { from{opacity:0;transform:translateY(-6px);}to{opacity:1;transform:translateY(0);} }
.abulk__bar { display:flex; align-items:center; gap:0.65rem; flex-wrap:wrap; background:rgba(var(--admin-rust-rgb), 0.06); border:1.5px solid rgba(var(--admin-rust-rgb), 0.25); border-radius:8px; padding:0.6rem 1rem; animation:slideDown 0.2s ease; }
.abulk__count { font-size:0.82rem; font-weight:700; color:var(--admin-rust); white-space:nowrap; }
.abulk__btn { font-size:0.78rem !important; padding:0.4rem 0.8rem !important; white-space:nowrap; }
`, "",{"version":3,"sources":["webpack://./src/admin/AdminDonations.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,SAAS;AACX;AACA;EACE,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,SAAS;EACT,cAAc;AAChB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,SAAS;AACX;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,SAAS;AACX;AACA;EACE,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,sBAAsB;EACtB,qCAAqC;EACrC,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,wBAAwB;EACxB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,yBAAyB;EACzB,qBAAqB;EACrB,4CAA4C;EAC5C,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,qBAAqB;EACrB,gCAAgC;EAChC,sBAAsB;AACxB;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;EACxB,SAAS;AACX;AACA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,SAAS;AACX;AACA;EACE,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;EACxB,mBAAmB;AACrB;AACA;EACE,kCAAkC;EAClC,yBAAyB;AAC3B;AACA;EACE,mCAAmC;EACnC,yBAAyB;AAC3B;AACA;EACE,kCAAkC;EAClC,uBAAuB;AACzB;;AAEA,iBAAiB;AACjB;EACE,gBAAgB;EAChB,qCAAqC;EACrC,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,qCAAqC;AACvC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,aAAa;EACb,4CAA4C;AAC9C;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;EACxB,SAAS;AACX;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,yBAAyB;EACzB,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,4CAA4C;AAC9C;AACA;EACE,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;EACxB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,4CAA4C;AAC9C;AACA;EACE,8BAA8B;EAC9B,iBAAiB;EACjB,gBAAgB;EAChB,wBAAwB;EACxB,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,6BAA6B;EAC7B,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,uBAAuB;AACzB;AACA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,4CAA4C;EAC5C,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,wBAAwB;EACxB,kBAAkB;AACpB;AACA;EACE,WAAW;AACb;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,4BAA4B;AAC9B;AACA;EACE,mCAAmC;AACrC;;AAEA;EACE;IACE,qCAAqC;EACvC;EACA;IACE,0BAA0B;EAC5B;AACF;AACA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA,cAAc,YAAY,EAAE,kBAAkB,EAAE,UAAU,EAAE,8BAA8B,EAAE,oCAAoC,EAAE,iBAAiB,EAAE,oBAAoB,EAAE,iBAAiB,EAAE,eAAe,EAAE,aAAa,EAAE,8BAA8B,EAAE;AAC9P,uBAAuB,KAAK,SAAS,CAAC,0BAA0B,CAAC,CAAC,GAAG,SAAS,CAAC,uBAAuB,CAAC,EAAE;AACzG,cAAc,YAAY,EAAE,kBAAkB,EAAE,WAAW,EAAE,cAAc,EAAE,4CAA4C,EAAE,oDAAoD,EAAE,iBAAiB,EAAE,mBAAmB,EAAE,6BAA6B,EAAE;AACxP,gBAAgB,iBAAiB,EAAE,eAAe,EAAE,uBAAuB,EAAE,kBAAkB,EAAE;AACjG,cAAc,4BAA4B,EAAE,gCAAgC,EAAE,kBAAkB,EAAE","sourcesContent":[".adn__stats-grid {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 1rem;\n}\n.adn__stat-card {\n  display: flex;\n  flex-direction: column;\n  gap: 0.4rem;\n}\n.adn__stat-top {\n  display: flex;\n  align-items: center;\n  gap: 0.7rem;\n}\n.adn__stat-icon {\n  width: 2.5rem;\n  height: 2.5rem;\n  border-radius: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n.adn__stat-label {\n  font-size: 0.82rem;\n  font-weight: 600;\n  color: var(--admin-muted);\n  margin: 0;\n}\n.adn__stat-value {\n  font-family: var(--font-body);\n  font-size: 2rem;\n  font-weight: 700;\n  color: var(--admin-text);\n  margin: 0;\n  line-height: 1;\n}\n.adn__stat-change {\n  display: flex;\n  align-items: center;\n  gap: 0.3rem;\n  font-size: 0.75rem;\n  font-weight: 500;\n  margin: 0;\n}\n.adn__stat-change.up {\n  color: var(--admin-green);\n}\n.adn__stat-change.down {\n  color: var(--admin-red);\n}\n\n.adn__layout {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 1rem;\n}\n.adn__layout--detail {\n  grid-template-columns: 1fr 340px;\n  align-items: start;\n}\n\n.adn__filters {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  flex-wrap: wrap;\n  margin-bottom: 0.75rem;\n}\n.adn__date-filter {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.6rem 0.9rem;\n  border: 1px solid var(--admin-border);\n  border-radius: 8px;\n  background: #fff;\n  font-size: 0.84rem;\n  color: var(--admin-text);\n  white-space: nowrap;\n  cursor: pointer;\n}\n\n.adn__table-card {\n  padding: 0;\n  overflow: hidden;\n}\n.adn__table {\n  width: 100%;\n  border-collapse: collapse;\n}\n.adn__table th {\n  font-size: 0.72rem;\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: var(--admin-muted);\n  padding: 0.75rem 1rem;\n  border-bottom: 1px solid var(--admin-border);\n  text-align: left;\n  background: #fafaf8;\n}\n.adn__table td {\n  padding: 0.85rem 1rem;\n  border-bottom: 1px solid #f0ebe4;\n  vertical-align: middle;\n}\n.adn__table tbody tr:last-child td {\n  border-bottom: none;\n}\n\n.adn__email-cell {\n  font-size: 0.82rem;\n  color: var(--admin-muted);\n}\n.adn__amount-cell {\n  font-size: 0.88rem;\n  font-weight: 700;\n  color: var(--admin-text);\n  margin: 0;\n}\n.adn__currency-cell {\n  font-size: 0.7rem;\n  color: var(--admin-muted);\n  margin: 0;\n}\n.adn__campaign-cell {\n  font-size: 0.82rem;\n  color: var(--admin-text);\n}\n\n.adn__badge {\n  display: inline-flex;\n  align-items: center;\n  font-size: 0.72rem;\n  font-weight: 600;\n  padding: 0.22rem 0.65rem;\n  border-radius: 99px;\n}\n.adn__badge--completed {\n  background: rgba(22, 163, 74, 0.1);\n  color: var(--admin-green);\n}\n.adn__badge--pending {\n  background: rgba(217, 119, 6, 0.12);\n  color: var(--admin-amber);\n}\n.adn__badge--refunded {\n  background: rgba(220, 38, 38, 0.1);\n  color: var(--admin-red);\n}\n\n/* Detail panel */\n.adn__detail {\n  background: #fff;\n  border: 1px solid var(--admin-border);\n  border-radius: 10px;\n  overflow: hidden;\n  position: sticky;\n  top: calc(var(--admin-topbar-h)+1rem);\n}\n.adn__detail-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 1rem;\n  border-bottom: 1px solid var(--admin-border);\n}\n.adn__detail-title {\n  font-size: 0.95rem;\n  font-weight: 700;\n  color: var(--admin-text);\n  margin: 0;\n}\n.adn__detail-close {\n  background: none;\n  border: none;\n  cursor: pointer;\n  font-size: 1rem;\n  color: var(--admin-muted);\n  padding: 0.2rem;\n  border-radius: 4px;\n}\n.adn__detail-close:hover {\n  background: #f3f4f0;\n}\n\n.adn__detail-user {\n  display: flex;\n  gap: 0.75rem;\n  padding: 1rem;\n  align-items: flex-start;\n  border-bottom: 1px solid var(--admin-border);\n}\n.adn__detail-avatar {\n  width: 2.4rem;\n  height: 2.4rem;\n  border-radius: 50%;\n  color: #fff;\n  font-size: 0.72rem;\n  font-weight: 700;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n.adn__detail-name {\n  font-size: 0.95rem;\n  font-weight: 700;\n  color: var(--admin-text);\n  margin: 0 0 0.15rem;\n}\n.adn__detail-email {\n  font-size: 0.75rem;\n  color: var(--admin-muted);\n  margin: 0 0 0.1rem;\n}\n\n.adn__detail-amount-block {\n  padding: 1rem;\n  border-bottom: 1px solid var(--admin-border);\n}\n.adn__detail-amount {\n  font-family: var(--font-serif);\n  font-size: 1.6rem;\n  font-weight: 700;\n  color: var(--admin-text);\n  margin: 0 0 0.4rem;\n}\n.adn__detail-amount span {\n  font-size: 0.85rem;\n  color: var(--admin-muted);\n  font-family: var(--font-body);\n  font-weight: 400;\n}\n.adn__detail-date {\n  font-size: 0.75rem;\n  color: var(--admin-muted);\n  margin: 0.4rem 0 0.1rem;\n}\n.adn__detail-txid {\n  font-size: 0.7rem;\n  color: var(--admin-muted);\n  margin: 0;\n  font-family: monospace;\n}\n\n.adn__detail-rows {\n  padding: 0.75rem 1rem;\n  border-bottom: 1px solid var(--admin-border);\n  display: flex;\n  flex-direction: column;\n  gap: 0.6rem;\n}\n.adn__detail-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: 0.75rem;\n}\n.adn__detail-key {\n  font-size: 0.78rem;\n  color: var(--admin-muted);\n  flex-shrink: 0;\n}\n.adn__detail-val {\n  font-size: 0.78rem;\n  font-weight: 500;\n  color: var(--admin-text);\n  text-align: right;\n}\n\n.adn__detail-actions {\n  padding: 0.85rem 1rem;\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n.adn__detail-section-title {\n  font-size: 0.8rem;\n  font-weight: 700;\n  color: var(--admin-text);\n  margin: 0 0 0.5rem;\n}\n.adn__action-full {\n  width: 100%;\n}\n.adn__refund-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.4rem;\n  width: 100%;\n  padding: 0.65rem;\n  border: none;\n  border-radius: 6px;\n  background: transparent;\n  color: var(--admin-red);\n  font-size: 0.82rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background 0.15s;\n}\n.adn__refund-btn:hover {\n  background: rgba(220, 38, 38, 0.06);\n}\n\n@media (max-width: 1199px) {\n  .adn__stats-grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n  .adn__layout--detail {\n    grid-template-columns: 1fr;\n  }\n}\n@media (max-width: 767px) {\n  .adn__stats-grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n\n.ann__toast { display:flex; align-items:center; gap:0.5rem; background:rgba(22,163,74,0.1); border:1px solid rgba(22,163,74,0.3); border-radius:8px; padding:0.65rem 1rem; font-size:0.84rem; font-weight:600; color:#16a34a; animation:slideDown 0.25s ease; }\n@keyframes slideDown { from{opacity:0;transform:translateY(-6px);}to{opacity:1;transform:translateY(0);} }\n.abulk__bar { display:flex; align-items:center; gap:0.65rem; flex-wrap:wrap; background:rgba(var(--admin-rust-rgb), 0.06); border:1.5px solid rgba(var(--admin-rust-rgb), 0.25); border-radius:8px; padding:0.6rem 1rem; animation:slideDown 0.2s ease; }\n.abulk__count { font-size:0.82rem; font-weight:700; color:var(--admin-rust); white-space:nowrap; }\n.abulk__btn { font-size:0.78rem !important; padding:0.4rem 0.8rem !important; white-space:nowrap; }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
